import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["onClick", "onMouseenter"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_star_filled_icon = _resolveComponent("star-filled-icon")!
  const _component_star_icon = _resolveComponent("star-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: "ratingContainer",
    onMouseleave: _cache[0] || (_cache[0] = ($event: any) => (_ctx.resetRating()))
  }, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (index) => {
      return _createElementVNode("button", {
        class: "rating",
        key: index,
        onClick: ($event: any) => (_ctx.setRating(index)),
        onMouseenter: ($event: any) => (_ctx.setDisplayRating(index))
      }, [
        (index <= _ctx.displayRating)
          ? (_openBlock(), _createBlock(_component_star_filled_icon, {
              key: 0,
              height: 24,
              width: 24,
              iconColor: _ctx.color
            }, null, 8, ["iconColor"]))
          : (_openBlock(), _createBlock(_component_star_icon, {
              key: 1,
              height: 24,
              width: 24,
              iconColor: _ctx.color
            }, null, 8, ["iconColor"]))
      ], 40, _hoisted_1)
    }), 64))
  ], 32))
}